import _ from 'lodash';
import getTripItineraries from '../getTripItineraries';
import { TravelTypes } from '../../constants';

const checkDoShowMarkupRates = ({
  mode, tripId, itineraryId = 0, trip = undefined,
}) => (store) => {
  const disableMultipleRoomBookings = !!(store && store.user && store.user.travelAgency
    && store.user.travelAgency.settings
    && store.user.travelAgency.settings.disableMultipleRoomBookings);

  const selectedTrip = store && tripId ? (store.trip.selectedTrips || {})[tripId] || {} : trip;
  if (!selectedTrip || _.isEmpty(selectedTrip)) return true;

  const tripItineraries = getTripItineraries(selectedTrip);

  if (disableMultipleRoomBookings) {
    if (_.find(tripItineraries, (it) => it.mode === mode
    && (it.mode !== TravelTypes.carrental || +it.id === +itineraryId)
    && (it.cost || {}).doShowMarkupAmount)) return true;
    return false;
  }

  const carItinerariesWithMarkup = tripItineraries.filter(
    (itinerary) => itinerary.mode === TravelTypes.carrental
    && (itinerary.cost || {}).doShowMarkupAmount,
  );

  const hotelItinerariesWithMarkup = tripItineraries.filter(
    (itinerary) => itinerary.mode === TravelTypes.hotel
    && (itinerary.cost || {}).doShowMarkupAmount,
  );

  if (mode === TravelTypes.hotel) {
    if (carItinerariesWithMarkup.length > 0) {
      return false;
    }
    return hotelItinerariesWithMarkup.length > 0
      && +hotelItinerariesWithMarkup[0].id === +itineraryId;
  }

  if (mode === TravelTypes.carrental) {
    if (hotelItinerariesWithMarkup.length > 0) {
      return false;
    }
    return carItinerariesWithMarkup.length > 0
      && +carItinerariesWithMarkup[0].id === +itineraryId;
  }

  // Fallback function for any other scenario
  const isMatchingItinerary = (itinerary) => {
    const isSameMode = itinerary.mode === mode;
    const isSameId = +itinerary.id === +itineraryId;
    const hasMarkupFlag = (itinerary.cost || {}).doShowMarkupAmount;
    return isSameMode && isSameId && hasMarkupFlag;
  };
  return !!_.find(tripItineraries, isMatchingItinerary);
};

export default checkDoShowMarkupRates;
